import React from "react";
import Avatar from "../Avatar";

/**
 * Célula de tabela com a foto do usuário ao lado do nome. Usada nas listagens
 * (orçamentos, pedidos, usuários) e no dashboard para exibir o responsável.
 */
export const UserCell = ({ name, photo, size = 22, initialFontSize, maxInitials }) => (
    <span className="user-cell">
        <Avatar
            name={name}
            photo={photo}
            size={size}
            initialFontSize={initialFontSize}
            maxInitials={maxInitials}
        />
        <span className="user-cell-name">{name || '—'}</span>
    </span>
);

export default UserCell;
